import { tokens } from '@welbe/web-design-system';
import styled from 'styled-components';

export const Link = styled.span<{ active?: boolean }>`
	font-weight: ${({ active }) => (active ? '600' : '400;')};
	color: ${({ active }) =>
		active ? tokens.color_primary : tokens.color_gray_dark};
	cursor: ${({ active }) => (active ? 'pointer' : 'not-allowed')};
`;
